import {stringify} from 'qs'

export default {
    namespaced: true,

    state: {
        active: [],
        loading: true,
        basePath: '',
        breadcrumbs: [],
        categoryId: null,
        categories: [],
        products: [],
        pagination: {},
        filters: {},
        sections: [],
        popularLinks: [],
        selected: {},
        description: {},
        lastUpdate: {},
        skipFilters: [],
        expandCategories: false,
        bestsellers: [],
        sortOptions: [],
        rangeFilters: [],
        filterList: [],
        activeSelected: {},
        promoCodeApplied: false,
        brandOptions: [],
        colors: [],
        dialogFiltersMobile: false,
        dialogFilterMobile: false,
        dialogCategoriesMobile: false,
        schemaOrg: '',
        categoryBrandTagsLabel: '',
        hideCategoryBrandTagsSection: false,
        similarProducts: []
    },

    getters: {
        isSlider: (state) => (filter) => {
            return state.rangeFilters.indexOf(filter) !== -1;
        },
        isActive: (state) => (filter) => {
            return state.active.includes(filter)
        },
        filterValues: (state) => (slug) => {
            return state.filters[slug] ? state.filters[slug] : []
        },
        hasFilterValues: (state, getters) => (slug) => {
            return getters.filterValues(slug).length !== 0
        },
        getFilterBySlug: (state) => (slug) => {
            return _.find(state.filterList, (filter) => filter.slug === slug)
        },
        findCategoryById: (state, getters) => (categories, categoryId) => {
            for (let i in categories) {
                if (categories[i].id === categoryId) {
                    return categories[i]
                }

                if (categories[i].subCategories && categories[i].subCategories.length) {
                    let category = getters.findCategoryById(categories[i].subCategories, categoryId)

                    if (category !== null) {
                        return category
                    }
                }
            }

            return null
        },
        getCategoryById: (state, getters) => (categoryId) => {
            return getters.findCategoryById(state.categories, categoryId)
        },
        selectedCategory(state, getters) {
            return getters.findCategoryById(state.categories, state.categoryId)
        },
        isReady(state) {
            return !state.loading
        },
        categoryName: (state, getters) => (categoryId) => {
            let category = getters.findCategoryById(state.categories, categoryId)

            return category ? category.name : ''
        },
        brandName: (state) => (brandId) => {
            const brands = state.filters.brand

            if (brands) {
                let brand = brands.find(item => item.value === brandId)

                return brand ? brand.name : ''
            }
        },
        selectedSortOption(state) {
            let sortOption = state.sortOptions.find(item => item.sort === state.selected.sort && item.dir === state.selected.dir)

            return sortOption ? sortOption : state.sortOptions[0]
        },
        changed(state) {
            return !_.isEqual(state.selected, state.lastUpdate)
        },

        mustBeSkipped: (state) => (filterSlug) => {
            return state.skipFilters.indexOf(filterSlug) !== -1
        },
    },
    mutations: {
        toggleDialogFiltersMobile(state, status) {
            Vue.set(state, 'dialogFiltersMobile', !!status)
        },
        toggleDialogFilterMobile(state, status) {
            Vue.set(state, 'dialogFilterMobile', !!status)
        },
        toggleDialogCategoriesMobile(state, status) {
            Vue.set(state, 'dialogCategoriesMobile', !!status)
        },
        setCategoryBrandTagsLabel(state, categoryBrandTagsLabel) {
            Vue.set(state, 'categoryBrandTagsLabel', categoryBrandTagsLabel)
        },
        setHideCategoryBrandTagsSection(state, hideCategoryBrandTagsSection) {
            Vue.set(state, 'hideCategoryBrandTagsSection', hideCategoryBrandTagsSection)
        },
        setColors(state, colors) {
            Vue.set(state, 'colors', colors)
        },
        setBrandOptions(state, options) {
            Vue.set(state, 'brandOptions', options)
        },
        setActive(state, slug) {
            Vue.set(state, 'active', slug)
        },
        setCategorySlug(state, slug) {
            Vue.set(state, 'categorySlug', slug)
        },
        setPromoCodeStatus(state, status) {
            Vue.set(state, 'promoCodeApplied', status)
        },
        setCategories(state, categories) {
            Vue.set(state, 'categories', _.sortBy(categories, ['name']))
        },
        setCategoryId(state, categoryId) {
            Vue.set(state, 'categoryId', categoryId)
        },
        setPagination(state, pagination) {
            Vue.set(state, 'pagination', pagination)
        },
        setProducts(state, products) {
            Vue.set(state, 'products', products)
        },
        setFilters(state, filters) {
            Vue.set(state, 'filters', filters)
        },
        setSections(state, sections) {
            Vue.set(state, 'sections', sections)
        },
        setFilterValue(state, {filter, values}) {
            Vue.set(state.filters, filter, values)
        },
        setExpandCategories(state, expandCategories) {
            Vue.set(state, 'expandCategories', expandCategories)
        },
        setPopularLinks(state, popularLinks) {
            Vue.set(state, 'popularLinks', popularLinks)
        },
        setBreadcrumbs(state, breadcrumbs) {
            Vue.set(state, 'breadcrumbs', breadcrumbs)
        },
        setSkipFilters(state, skipFilters) {
            Vue.set(state, 'skipFilters', skipFilters)
        },
        setDescription(state, description) {
            Vue.set(state, 'description', description)

            // unable to change meta data with vue, so, do it on vanilla js
            document.querySelector('head meta[name="description"]')
                .setAttribute('content', state.description ? state.description.meta_description : '')
            document.querySelector('head title').textContent = state.description ? state.description.meta_title : ''
        },
        setSchemaOrg(state, data) {
            for (let i in data) {
                let scriptElement = null;
                document.querySelectorAll('[type="application/ld+json"]').forEach(function (el) {
                    let content = JSON.parse(el.innerHTML);

                    if (data[i]['@type'] !== undefined
                        && content['@type'] !== undefined
                        && data[i]['@type'] === content['@type']
                    ) {
                        scriptElement = el;
                    }
                });

                if (scriptElement) {
                    scriptElement.innerHTML = JSON.stringify(data[i]);
                } else {
                    scriptElement = document.createElement('script');
                    scriptElement.setAttribute('type', 'application/ld+json');
                    scriptElement.innerHTML = JSON.stringify(data[i]);
                    document.body.appendChild(scriptElement);
                }
            }
        },
        setBestsellers(state, bestsellers) {
            Vue.set(state, 'bestsellers', bestsellers)
        },
        setSelected(state, selected) {
            selected = _.isEmpty(selected) ? {} : selected
            _.each(selected, function (values, key) {
                if (_.isArray(values)) {
                    selected[key] = values.map(i => {
                        if (i && i.toString().indexOf('-')) {
                            return i;
                        }

                        return parseFloat(i);
                    });
                } else {
                    selected[key] = _.isNumber(values) ? parseFloat(values) : values;
                }
            })

            let selectedFilters = {}
            _.each(state.filters, function (values, prop) {
                if (selected[prop] && values && (typeof values === "object") && values.hasOwnProperty('min') && values.hasOwnProperty('max')) {
                    selectedFilters[prop] = {}
                    selectedFilters[prop]['min'] = selected[prop].min
                    selectedFilters[prop]['max'] = selected[prop].max
                    selectedFilters[prop]['appendix'] = selected[prop].appendix
                    delete selected[prop]
                } else {
                    _.each(values, function (value) {
                        let filters = {}
                        if (typeof value.value != 'undefined') {
                            if (_.isArray(value.value)) {
                                filters[prop] = value.value
                            } else {
                                filters[prop] = []
                                filters[prop].push(value.value)
                            }
                        }
                        if (value.params) {
                            filters = Object.assign(filters, value.params)
                        }

                        _.each(filters, function (filterValues, filterProp) {
                            if (selected[filterProp] && _.indexOf(['sort', 'dir'], filterProp) === -1) {
                                _.each(filterValues, function (v) {
                                    selected[filterProp] = _.map(selected[filterProp], (val) => val.toString())

                                    let i = _.indexOf(selected[filterProp], v.toString())

                                    if (i >= 0) {
                                        if (!selectedFilters[prop]) {
                                            selectedFilters[prop] = []
                                        }
                                        selectedFilters[prop].push({value: value.value, params: value.params})

                                        if (selected[filterProp][i]) {
                                            selected[filterProp].splice(i, 1)
                                        }
                                        if (selected[filterProp].length === 0) {
                                            delete selected[filterProp]
                                        }
                                    }
                                })
                            }
                        })
                    })
                }
            })

            if (!_.isEmpty(selected)) {
                selectedFilters = Object.assign(selectedFilters, selected)
            }
            Vue.set(state, 'selected', selectedFilters)

            if (_.isEmpty(state.lastUpdate)) {
                Vue.set(state, 'lastUpdate', _.cloneDeep(selectedFilters))
            }
        },

        setPage(state, page) {
            if (page !== 1) {
                Vue.set(state.selected, 'page', page)
            } else {
                Vue.delete(state.selected, 'page')
            }
        },

        setBasePath(state, basePath) {
            Vue.set(state, 'basePath', basePath ? basePath.replace(/[\/]+$/g, "") + '/' : '')
        },

        setRangeFilters(state, rangeFilters) {
            Vue.set(state, 'rangeFilters', rangeFilters)
        },

        syncLastUpdate(state) {
            state.lastUpdate = _.cloneDeep(state.selected)
        },

        unsetPage(state) {
            Vue.delete(state.selected, 'page')
        },

        loading(state) {
            Vue.set(state, 'loading', true)
        },

        loaded(state) {
            Vue.set(state, 'loading', false)
        },

        setSortOptions(state, options) {
            Vue.set(state, 'sortOptions', options)
        },

        setSortOption(state, index) {
            let sort = state.sortOptions[index] ? state.sortOptions[index].sort : false
            let dir = state.sortOptions[index] ? state.sortOptions[index].dir : false

            if (!sort || !dir || (sort === 'default')) {
                Vue.delete(state.selected, 'sort')
                Vue.delete(state.selected, 'dir')
            } else {
                Vue.set(state.selected, 'sort', sort)
                Vue.set(state.selected, 'dir', dir)
            }
        },

        setFilterList(state, list) {
            Vue.set(state, 'filterList', list)
        },

        setActiveSelected(state, filters) {
            Vue.set(state, 'activeSelected', filters)
        },

        setSimilarProducts(state, similarProducts) {
            Vue.set(state, 'similarProducts', similarProducts)
        }
    },

    actions: {
        setPage({commit, dispatch}, page) {
            commit('setPage', page)

            dispatch('update')
        },

        setCategoryId({state, commit, dispatch}, categoryId) {
            if (categoryId !== state.categoryId) {
                commit('setCategoryId', categoryId)

                commit('unsetPage')

                dispatch('update')
            }
        },

        applyFilters({getters, commit, dispatch}) {
            if (getters.changed) {
                commit('unsetPage')

                dispatch('update')
            }
        },

        clearFilterSelection({state, commit, dispatch}, filter) {
            Vue.delete(state.selected, filter)

            if (filter === 'sort') {
                Vue.delete(state.selected, 'dir')
            }

            dispatch('applyFilters')
        },

        clearAllFilterSelection({state, dispatch}) {
            const selected = {
                category: state.selected.category
            }

            Vue.set(state, 'selected', selected)

            dispatch('applyFilters')
        },

        setSorting({commit, dispatch}, index) {

            commit('setSortOption', index)

            dispatch('applyFilters')
        },

        async update({state, getters, commit}) {
            if (getters.isReady) {
                commit('loading')

                let url = window.location.href.replace(/\/?(\?|#|$)/, '/$1')

                try {
                    let referrers = localStorage.getItem('referrers')
                    referrers = referrers ? referrers.split('|') : []
                    referrers.push(url)
                    referrers = _.uniq(referrers).join('|')

                    localStorage.setItem('referrers', referrers)
                    localStorage.setItem('previous', url)
                } catch (e) {
                    console.log(e)
                }

                window.history.pushState(null, null, url)

                let categorySlug = getters.selectedCategory ? getters.selectedCategory.slug : ''

                if (!categorySlug || !state.selected['category'] || !state.selected['category'].length || (state.selected['category'].length !== 1) || (state.selected['category'][0].value !== state.categoryId)) {
                    // search for root category
                    let rootCategory = state.categories.find(category => !category.parent_id);

                    if (rootCategory) {
                        commit('setCategoryId', rootCategory.id);

                        categorySlug = rootCategory.slug;
                    }
                }

                url = state.basePath + categorySlug

                // TODO: need to change
                if (!getters.selectedCategory) {
                    if (window.location.href.split('/').includes('sale')) {
                        url += 'sale/'
                    }
                }
                url = url.replace(/\/?(\?|#|$)/, '/$1')

                let requestSelected = {}
                _.each(state.selected, function (values, prop) {
                    if (_.isObject(values) && values.hasOwnProperty('min') && values.hasOwnProperty('max')) {
                        requestSelected[prop] = [
                            values.min,
                            values.max
                        ]
                    } else if (_.isArray(values) || _.isObject(values)) {
                        _.each(values, function (filter) {
                            if (!requestSelected[prop]) {
                                requestSelected[prop] = []
                            }
                            if (!filter.value) {
                                requestSelected[prop].push(filter)
                            } else {
                                requestSelected[prop].push(filter.value)
                            }
                            requestSelected[prop] = _.uniq(_.flatten(requestSelected[prop]))

                            if (filter.params) {
                                _.each(filter.params, function (value, key) {
                                    if (_.isArray(requestSelected[key])) {
                                        requestSelected[key].push(value)
                                        requestSelected[key] = _.uniq(_.flatten(requestSelected[key]))
                                    } else {
                                        requestSelected[key] = value
                                    }
                                })
                            }
                        })
                    } else {
                        requestSelected[prop] = values
                    }
                })

                let requestParams = {
                    params: requestSelected
                }

                // one filter selected
                let firstFilter = Object.keys(state.selected)[0]

                let specialFilter = Object.keys(state.selected).length === 1 && state.selected[firstFilter] && state.selected[firstFilter].length === 1
                    ? getters
                        .filterValues(firstFilter)
                        .find(filter => _.isEqual({
                            value: filter.value,
                            params: filter.params
                        }, state.selected[firstFilter][0]))
                    : null

                if (specialFilter && specialFilter.url) {
                    url = specialFilter.url

                    requestParams.params = {}
                }

                _.each(requestParams.params, function (values, key) {
                    requestParams.params[key] = _.isArray(values) ? values.join(process.env.MIX_CATALOG_PARAMS_SEPARATOR) : values
                })

                let selected = Object.keys(requestParams.params).length
                    ? '?' + stringify(requestParams.params, {encodeValuesOnly: true, arrayFormat: 'brackets'})
                    : ''

                try {
                    let referrers = localStorage.getItem('referrers')
                    referrers = referrers.split('|')
                    referrers.push(url + selected)
                    referrers = _.uniq(referrers).join('|')

                    localStorage.setItem('referrers', referrers)
                    localStorage.setItem('previous', url + selected)
                } catch (e) {
                    console.log(e)
                }

                axios.get(url + '?load', requestParams)
                    .then(response => {
                        if (response.data.status === 'success' && response.data.products.length) {
                            commit('setCategoryBrandTagsLabel', response.data.categoryBrandTagsLabel)
                            commit('setHideCategoryBrandTagsSection', response.data.hideCategoryBrandTagsSection)
                            commit('setPagination', response.data.pagination)
                            commit('setProducts', response.data.products)
                            commit('setFilters', response.data.filters)
                            commit('setCategories', response.data.categories)
                            commit('setPopularLinks', response.data.popularLinks)
                            commit('setBreadcrumbs', response.data.breadcrumbs)
                            commit('setSelected', response.data.selected)
                            commit('setDescription', response.data.description)
                            commit('setSkipFilters', response.data.skipFilters)
                            commit('setExpandCategories', response.data.expandCategories)
                            commit('setBestsellers', response.data.bestsellers)
                            commit('setSchemaOrg', response.data.schemaOrg)
                        } else {
                            commit('setProducts', [])
                        }

                        let link = !!document.querySelector("link[rel='canonical']") ?
                            document.querySelector("link[rel='canonical']") : document.createElement('link');
                        link.setAttribute('rel', 'canonical');
                        link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
                        document.head.appendChild(link);

                        // TODO try : store url & requestParams in state, add it on pushState, onpopstate history - extract it, put to the vuex and reload based on it
                        window.history.replaceState(null, null, url + selected)

                        commit('syncLastUpdate')
                        commit('loaded')
                    })
                    .catch(() => {
                        window.history.replaceState(null, null, url + selected)
                        commit('setProducts', [])
                        commit('loaded')
                    })
            }
        },
    }
}
